import { memo } from "react";

export const Page404 = memo(() => {
  return <p>404ページ</p>;
});
